"use client"
import Button from "@/app/ui/forms/ButtonNF";
import { GoogleAnalyticsEvent } from "@/lib/utils";
import { signIn } from "next-auth/react";
import { useSearchParams } from "next/navigation";
import { Suspense } from "react";
import { BsDiscord } from "react-icons/bs";

export default function LoginBtn() {
    return <Suspense fallback={ <Btn /> } >
        <ClientBtn />
    </Suspense>
}
function Btn({ callbackUrl }: { callbackUrl?: string }) {
    return <Button className="px-8 py-3 text-3xl" color="nfPurple" onClick={ () => {
        GoogleAnalyticsEvent({ event_name: "login", event_value: undefined });
        signIn("discord", { callbackUrl });
    } }>
        התחבר עם
        <BsDiscord style={ { display: "inline-block" } } />
    </Button>
}

function ClientBtn() {
    const searchParams = useSearchParams();
    const callbackUrl = searchParams.get("callbackUrl") || undefined;

    return <Btn callbackUrl={ callbackUrl } />
}